(ns shared.core.amelia-light.components.waffle-menu
  (:require [clojure.string :as s]
            [shared.core.amelia-light.components.icon :as alc-icon]
            [shared.core.reactive :as re]
            ["@up/base-ui/components/ui/badge" :refer [Badge]]
            ["@up/base-ui/components/ui/button" :refer [buttonVariants]]
            ["@up/base-ui/components/ui/command" :refer [Command CommandGroup CommandItem CommandList]]
            ["@up/base-ui/components/ui/popover" :refer [Popover PopoverContent PopoverTrigger]]
            ["@up/base-ui/icons/common/DoneIcon" :default DoneIcon]
            ["@up/base-ui/icons/common/TilesMenuIcon" :default TilesMenuIcon]))

(def ^:private trigger-class
  (buttonVariants #js {:variant "ghost" :icon "md"}))

(defn- default-is-active-item [item-url current]
  (boolean (and current item-url (s/starts-with? current item-url))))

(defn- section-heading [{:keys [title labels]}]
  (when title
    [:div {:class-name "flex w-full justify-between text-xs"}
     [:span {:class-name "text-up-text-secondary uppercase"} title]
     (for [label labels]
       ^{:key label}
       [:> Badge {:variant "secondary"
                  :class-name "rounded-full px-2 py-0 ps-1.5 pe-1.5 text-xs"}
        label])]))

(defn- item-icon [{:keys [icon-type icon-src icon-style]}]
  (let [Icon (get alc-icon/up-icons icon-type)]
    [:div {:aria-hidden true
           :style {:position :relative
                   :flex-shrink 0
                   :width 20
                   :height 20}}
     (cond
       icon-src
       [:img {:src icon-src
              :alt ""
              :style (merge {:position :absolute
                             :inset 0
                             :width "100%"
                             :height "100%"}
                            icon-style)}]

       Icon
       [:> Icon {:class-name "size-5 text-up-icons-primary"}])]))

(defn- menu-item [_]
  (let [hover?* (re/ratom false)]
    (fn [{:keys [title description url active? on-select] :as item}]
      [:> CommandItem {:value title
                       :as-child true}
       [:a (cond-> {:href url
                    :on-click on-select
                    :on-mouse-enter #(reset! hover?* true)
                    :on-mouse-leave #(reset! hover?* false)
                    :style {:display :flex
                            :align-items :center
                            :gap 8
                            :width "100%"
                            :padding "8px 12px 8px 8px"
                            :border-radius 4
                            :white-space :normal
                            :background (cond
                                          active? "var(--background-active_secondary)"
                                          @hover?* "var(--background-hover)"
                                          :else :transparent)}}
                   active? (assoc :aria-current "page"))
        [item-icon item]
        [:div {:style {:flex "1 0 0"
                       :min-width 0
                       :display :flex
                       :flex-direction :column}}
         [:span {:style {:font-size 14
                         :line-height "21px"
                         :color "var(--text-primary)"}}
          title]
         (when description
           [:span {:style {:font-size 12
                           :line-height "16px"
                           :color "var(--text-secondary)"}}
            description])]
        (when active?
          [:span {:class-name "sr-only"} "Current page"])
        [:> DoneIcon {:aria-hidden true
                      :style {:flex-shrink 0
                              :width 16
                              :height 16
                              :opacity (if active? 1 0)
                              :color "var(--text-primary)"}}]]])))

(defn up-waffle-menu [_]
  (let [open?* (re/ratom false)]
    (fn [{:keys [menu-sections active-item is-active-item icon-component trigger align-offset side-offset]}]
      (let [is-active? (or is-active-item default-is-active-item)
            Icon (or icon-component TilesMenuIcon)
            section-count (count menu-sections)]
        [:> Popover {:open @open?* :on-open-change #(reset! open?* %)}
         [:> PopoverTrigger {:as-child true}
          (if trigger
            (trigger @open?*)
            [:button {:type "button"
                      :class-name trigger-class
                      :style (when @open?*
                               {:background "var(--background-active)"})}
             [:> Icon]
             [:span {:class-name "sr-only"} "Open menu"]])]
         [:> PopoverContent {:align "start"
                             :align-offset (or align-offset 0)
                             :side-offset (or side-offset 4)
                             :style {:width 264
                                     :padding 6
                                     :background "var(--background-up_level)"
                                     :border :none
                                     :border-radius 6
                                     :box-shadow "inset 0 0 0 1px var(--border-divider), 0 2px 4px rgba(0, 0, 0, 0.03), 0 6px 18px rgba(0, 0, 0, 0.08)"}}
          [:> Command {:style {:padding 0
                               :background :transparent}}
           [:> CommandList {:class-name "max-h-full"}
            (doall
              (map-indexed
                (fn [idx {:keys [title items] :as section}]
                  ^{:key (or title idx)}
                  [:> CommandGroup {:value (or title (str "section-" idx))
                                    :heading (when title
                                               (re/as-element [section-heading section]))
                                    :style (cond-> {:padding 0}
                                                   (< idx (dec section-count))
                                                   (assoc :margin-bottom 8))}
                   [:div {:style {:display :flex
                                  :flex-direction :column
                                  :gap 8}}
                    (for [{:keys [title url] :as item} items]
                      ^{:key title}
                      [menu-item (assoc item
                                   :active? (is-active? url active-item)
                                   :on-select #(reset! open?* false))])]])
                menu-sections))]]]]))))
